<template>
  <div class="order-details">
    <ul>
      <li
        :class="onLi==item?'div-li div-onli':' div-li'"
        v-for="(item,index) in liList"
        :key="index"
        @click="checkLi(item)"
      >{{item}}</li>
    </ul>
    <div v-if="onLi=='订单详情'">
      <van-field v-model="pType" label="订单编号：" readonly />
      <van-field v-model="pName" label="产品名称：" readonly />
      <van-field v-model="name" label="客户姓名：" readonly />
      <van-field v-model="cID" label="客户身份证：" readonly />
      <van-field v-model="phone" label="客户手机号：" readonly />
      <van-field
        readonly
        clickable
        name="area"
        :value="area"
        label="所在省市："
        @click="showArea = true"
      />
      <van-field v-model="pName" label="审核状态：" readonly />
      <van-field v-model="pName" label="发佣状态：" readonly />
      <van-field v-model="pName" label="保险类型：" readonly />
      <van-field v-model="pName" label="总佣金率（%）：" readonly />
      <van-field v-model="pName" label="佣金金额（元）：" readonly />
      <van-field v-model="pName" label="进件时间：" readonly />
      <van-field v-model="pName" label="放款时间：" readonly />
      <van-field v-model="pName" label="经纪人姓名：" readonly />
      <van-field
        readonly
        v-model="consult"
        type="textarea"
        label="备注："
        autosize
        show-word-limit
        rows="3"
      />
    </div>
    <div v-if="onLi=='订单过程'">
      <van-steps direction="vertical"  active-color="#FC6E09" :active="active">
        <van-step v-for="(item,index) in stepList" :key="index">
          <p>{{item.time}} <span class="step-span"> {{item.name}}</span></p>
          <p class="step-p">{{item.stage}}</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      onLi: '订单详情',
      liList: ['订单详情', '订单过程'],
      pType: '0',//产品类型
      pName: '0',//产品名称
      name: '',//客户姓名
      cID: '',//客户身份证号
      phone: '',//客户手机号
      area: '',//地区选择
      consult: '',//咨询内容
      active:1,
      stepList:[
          {//步骤条数据
            time:'2022-04-24 14:23:34',
            stage:'提交进件信息',
            name:'张三',
          },
          {//步骤条数据
            time:'2022-05-14 14:23:34',
            stage:'审批通过',
            name:'保险公司名称',
          },
          {//步骤条数据
            time:'2022-05-23 14:23:34',
            stage:'审批通过',
            name:'审批人名称',
          },
          {//步骤条数据
            time:'2022-05-23 14:23:34',
            stage:'发放佣金',
            name:'发放佣金人名称',
          },

      ],
    }
  },
  methods: {
    checkLi(item) {
      this.onLi = item
    },
  }
}
</script>

<style lang="less" scoped>
.order-details {
  height: 100vh;
  background: #ffffff;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  overflow: scroll;
  ul {
    display: flex;
    .div-li {
      width: 188px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      background: url("../../assets/publicImg/li-bg1.png") no-repeat 50%;
      background-size: 100% 100%;
    }
    .div-onli {
      background: url("./img/bg2.png") no-repeat 50%;
      color: #ffffff;
    }
  }
  .van-cell {
    font-size: 12px;
    /deep/.van-field__label {
      width: 111px;
    }
  }
  .van-step{
    // line-height: 28px;
    .step-span{
      padding-left: 10px;
    }
    .step-p{
      // line-height: 30px;
      padding-top: 10px;
    }
  }
}
</style>